export class LoggedInUserDto {
    userName: string;
    email: string;
    userRole: string;
}
